import { UtilitiesService } from './../../services/utilities.service';
import { trigger, transition, style, animate } from '@angular/animations';
import {
  Component,
  Input,
  OnInit,
  Sanitizer,
  SecurityContext,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgxTippyProps } from 'ngx-tippy-wrapper';

import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-link-view',
  templateUrl: './link-view.component.html',
  styleUrls: ['./link-view.component.css'],
  animations: [
    trigger('inOutAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('1s ease-out', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('0s ease-in', style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class LinkViewComponent implements OnInit {
  tippyImageProps: NgxTippyProps = {
    trigger: 'click mouse-outside click-outside',
    followCursor: false,
    allowHTML: true,
    appendTo: document.body,
    interactive: true,
    // theme: 'clean'
  };

  @Input() url: string;
  @Input() title: string;
  @Input() description: string;
  @Input() placeholder: string = 'URL will be displayed here';
  @Input() enableShare: boolean = false;
  @Input() minimal: boolean = false;

  copying = false;
  // offerUrl: string = '';

  networksList = [
    { key: 'facebook', icon: 'facebook.svg' },
    { key: 'twitter', icon: 'twitter.svg' },
    { key: 'linkedin', icon: 'linkedin.svg' },
    { key: 'instagram', icon: 'instagram.svg' },
    { key: 'whatsapp', icon: 'whatsapp.svg' },
    { key: 'telegram', icon: 'telegram.svg' },
  ];

  shareUrls: {
    facebook: any;
    twitter: any;
    linkedin: any;
    instagram: any;
    whatsapp: any;
    telegram: any;
  } = {
    facebook: null,
    twitter: null,
    linkedin: null,
    instagram: null,
    whatsapp: null,
    telegram: null,
  };

  @Input('url') set URLSetter(value: string) {
    this.url = value;
  }
  @Input() shareConfig: {
    facebook?: { enabled: boolean; message?: string };
    twitter?: { enabled: boolean; message?: string; hashtags?: string[] };
    instagram?: { enabled: boolean; message?: string };
    linkedin?: { enabled: boolean; message?: string };
    whatsapp?: { enabled: boolean; message?: string };
    telegram?: { enabled: boolean; message?: string };
  } = {
    facebook: { enabled: true },
    twitter: { enabled: true },
    instagram: { enabled: false },
    linkedin: { enabled: true },
    whatsapp: { enabled: true },
    telegram: { enabled: false },
  };

  @Input() hashtags: string[] = [];

  platformDefaultMessages = {
    facebook: 'Check this out!',
    twitter: 'Have a look at this!',
    linkedin: 'Check this out!',
    whatsapp: 'Hey! Thought you’d like this:',
    telegram: 'Sharing something interesting with you:',
    instagram: 'Look at this post!',
  };

  constructor(
    private toastr: ToastrService,
    private utilitiesService: UtilitiesService,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.buildShareUrls();
  }

  copyText() {
    this.copying = true;

    this.utilitiesService.copyToClipboard(this.url);

    setTimeout(() => {
      this.copying = false;
      this.toastr.success('Done!', 'URL copied to clipboard', {
        closeButton: false,
        positionClass: 'toast-bottom-right',
      });
    }, 600);
  }

  getPlatformMessage(platform: string, cfgMessage?: string) {
    // 1) Use platform custom message
    if (cfgMessage) return encodeURIComponent(cfgMessage);

    // 2) Use global shareMessage
    const global = this.getMessage(platform);
    if (global) return global;

    // 3) Fallback to platform default
    return encodeURIComponent(this.platformDefaultMessages[platform] || '');
  }

  getMessage(platform: string) {
    let message = this.platformDefaultMessages[platform];
    return message;
  }

  getHashtags() {
    let hashtags = this.hashtags.join(',');

    return encodeURIComponent(hashtags);
  }

  buildShareUrls() {
    const cfg = this.shareConfig;

    const defaultHashtags = this.getHashtags();

    if (cfg.facebook?.enabled) {
      const msg = this.getMessage('facebook');
      this.shareUrls.facebook = this.sanitizer.bypassSecurityTrustUrl(
        `https://www.facebook.com/sharer/sharer.php?u=${this.url}`,
      );
    }

    if (cfg.twitter?.enabled) {
      const msg = this.getMessage('twitter');
      const tags = cfg.twitter.hashtags?.length
        ? cfg.twitter.hashtags.join(',')
        : defaultHashtags;

      this.shareUrls.twitter = this.sanitizer.bypassSecurityTrustUrl(
        `https://twitter.com/intent/tweet?text=${msg}&url=${this.url}&hashtags=${tags}`,
      );
    }

    if (cfg.whatsapp?.enabled) {
      const msg = this.getMessage('whatsapp');
      this.shareUrls.whatsapp = this.sanitizer.bypassSecurityTrustUrl(
        `https://wa.me/?text=${msg}\n${this.url}`,
      );
    }

    if (cfg.instagram?.enabled) {
      const msg = this.getMessage('instagram');
      this.shareUrls.instagram = this.sanitizer.bypassSecurityTrustUrl(
        `https://www.instagram.com/share?text=${msg}&url=${this.url}`,
      );
    }

    if (cfg.linkedin?.enabled) {
      const msg = this.getMessage('linkedin');
      this.shareUrls.linkedin = this.sanitizer.bypassSecurityTrustUrl(
        `https://www.linkedin.com/shareArticle?mini=true&url=${this.url}&title=${msg}`,
      );
    }

    if (cfg.telegram?.enabled) {
      const msg = this.getMessage('telegram');
      this.shareUrls.telegram = this.sanitizer.bypassSecurityTrustUrl(
        `https://t.me/share/url?url=${this.url}&text=${msg}`,
      );
    }
  }
}
